// extracted by mini-css-extract-plugin
export default {"tab":"FieldTypes_tab__3--iM"};